import { apiUrl } from '../../config/api';
export const ADMIN_API_URL = apiUrl('/api');

export const getAdminToken = () => sessionStorage.getItem('eulua_admin_token');

export const adminRequest = async (path, options = {}) => {
  const token = getAdminToken();
  const headers = { ...(options.headers || {}) };
  if (!(options.body instanceof FormData)) headers['Content-Type'] = 'application/json';
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${ADMIN_API_URL}${path}`, { ...options, headers });
  const data = await response.json().catch(() => ({}));
  if (response.status === 401 && token) {
    sessionStorage.removeItem('eulua_admin_token');
    window.dispatchEvent(new Event('eulua-admin-session-expired'));
  }
  if (!response.ok) throw new Error(data.error || 'The request could not be completed');
  return data;
};
